/*!
 * SPDX-License-Identifier: AGPL-3.0-only
 * 
 * PV Tool — AGPL Community Edition
 * Based on the last AGPL-3.0 version published on 2026-03-18
 * 
 * Copyright (c) 2026 DanteAlighieri13210914
 * Copyright (c) 2026 Contributors to PV Tool AGPL Community Edition
 * 
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, version 3 of the License.
 * 
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 * 
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.
 * 
 * Source repository: https://github.com/yandujun363/pv-tool-agpl
 */

export const zh = {
  // Page
  'page_title': 'PV Tool AGPL Community Edition - 日式PV Visual生成',
  'initializing': '正在初始化 PV Tool AGPL Community Edition...',
  'initializing_desc': '请稍候，首次加载需要检测显示器刷新率',

  // Panel titles
  'postfx': '後期 Post FX',
  'effects_library': '效果库 Effects',

  // Left panel
  'template': '模板 Template',
  'custom': '✦ Custom 自定义',
  'canvas_color': '画布色 Canvas',
  'follow_template': '跟随模板',
  'text_label': '文字 Text（用 / 分段）',
  'expand': '展开',
  'collapse': '收起',
  'seg_duration': '段落间隔',
  'anim_speed': '动画速度',
  'motion_intensity': '运动幅度',
  'bg_opacity': '背景透明度',
  'media': '媒体 Media',
  'media_mode': '媒体模式 Mode',
  'auto_fit': '自动适配 Auto Fit',
  'free_mode': '自由模式 Free',
  'apply': '应用 Apply',
  'audio': '音乐 Audio',
  'pause': '⏸ 暂停',
  'play': '▶ 播放',
  'playing': '♪ Playing',
  'paused': '⏹ Paused',
  'bpm': 'BPM',
  'beat_react': '节拍反应 Beat React',

  // Right panel — Post FX
  'shake': '抖动 Shake',
  'zoom': '缩放 Zoom',
  'tilt': '倾斜 Tilt',
  'glitch': '故障 Glitch',
  'hue_shift': '色相偏移 Hue',
  'media_position': '原图位置 Media Position',
  'offset_x': 'X偏移',
  'offset_y': 'Y偏移',
  'scale': '缩放',
  'rec': '录制 REC',
  'stop': '停止 STOP',
  'packing': '打包中...',
  'alpha_export': '透明背景导出 Alpha',
  'srt_import': '字幕时间轴 SRT',
  'lrc_import': '导入 LRC',
  'timer_label': '计时 Time',


  'render': '渲染设置',
  'render_resolution': '渲染分辨率',
  'render_resolution_auto': '自动 (根据性能)',
  'render_resolution_1x': '1x (标准)',
  'render_resolution_1_5x': '1.5x (高)',
  'render_resolution_2x': '2x (超高)',
  'render_resolution_custom': '自定义宽x高',
  'render_resolution_width': '宽度',
  'render_resolution_height': '高度',
  'render_resolution_apply': '应用',
  'render_fps': '帧率限制',
  'render_fps_auto': '自动 (最高)',
  'render_fps_30': '30 FPS',
  'render_fps_60': '60 FPS',
  'render_fps_custom': '自定义',
  'render_fps_value': 'FPS',
  'render_fps_current': '当前帧率: {fps}',
  'fps_warning_exceed_monitor': '设置的FPS({fps})超过显示器刷新率({max})，可能导致画面撕裂',
  'render_scale_mode': '画面缩放模式',
  'scale_mode_stretch': '拉伸填满 (全屏)',
  'scale_mode_contain': '保持比例 (黑边)',
  
  // Right panel — Export
  'export': '导出 Export',
  'copy_url': '复制 URL',

  // Right panel — Live mode
  'listen': '直播 mode',
  'listen_now_playing': '监听 Now Playing',

  // Color swatch titles
  'white': '白',
  'black': '黑',
  'blue': '蓝',
  'red': '红',
  'yellow': '黄',
  'pink': '粉',
  'p5red': 'P5红',

  // Effect categories
  'cat_background': '背景',
  'cat_geometry': '几何装饰',
  'cat_lines': '线条结构',
  'cat_text': '文字',
  'cat_overlay': '叠加效果',
  'cat_hud': 'HUD',
  'cat_organic': '有机形态',
  'cat_grunge': '数字废墟',
  'cat_special': '特殊形状',

  // Template names
  'tpl_p5': 'P5',
  'tpl_blueBold': '蓝色冲击',
  'tpl_kineticSplit': '斩击',
  'tpl_bluePlane': '蓝色构成(建议配合视频使用)',
  'tpl_cyberGrunge': '赛博废墟',
  'tpl_geometric': '几何',
  'tpl_rainCity': '黑客帝国',
  'tpl_cyberpunkHud': '夜之城监控(建议配合视频使用)',
  'tpl_emotionCinema': '情绪电影(建议配合视频使用)',
  'tpl_hystericNight': '歇斯底里之夜(光敏慎点)',
  'tpl_spiderWeb': '蛛网',
  'tpl_staggeredText': '错落文字',
  'tpl_calmVillain': '冷静的反派',
  'tpl_girlyClouds': '少女云朵',
  'tpl_sweetPink': '格子花边',
  'tpl_flyMeToTheMoon': 'Fly Me to the Moon',
  'tpl_kawaiPixel': 'Kawaii像素',

  // File picker
  'choose_file': '选择文件',
  'no_file': '未选择文件',

  //Export and import project
  'project_file': '工程文件',
  'export_project': '导出工程',
  'import_project': '导入工程',
  'export_success': '导出成功',
  'import_success': '导入成功',
  'import_failed': '导入失败',
  'project_file_desc': 'PV Tool CE 工程文件 (.pvtoolce)',
  'confirm_import': '导入将替换当前配置，是否继续？',
  'export_with_resources': '包含资源文件',
  'export_with_media': '包含背景媒体',
  'export_with_audio': '包含音频',
  'export_with_lyrics': '包含歌词',
  'lrc_imported': '歌词已导入',


  // Sharecode & template management
  'export_code': '导出分享码',
  'export_json_confirm': '导出为 JSON 格式（可读）？\n确定=JSON，取消=原版二进制',
  'import_code': '导入分享码',
  'import_btn': '导入',
  'code_copied': '分享码已复制到剪贴板',
  'code_invalid': '分享码无效',
  'save_tpl': '保存',
  'delete_tpl': '删除',
  'confirm': '确认',
  'cancel': '取消',
  'tpl_name_placeholder': '输入模板名称...',
  'confirm_delete': '确认删除',
  'share_code': '分享码 Share Code',
  'copy': '复制',
  'paste_code': '粘贴分享码...',


  // Effect categories (used in custom panel)
  'ecat_背景': '背景',
  'ecat_几何装饰': '几何装饰',
  'ecat_线条结构': '线条结构',
  'ecat_文字': '文字',
  'ecat_叠加效果': '叠加效果',
  'ecat_HUD': 'HUD',
  'ecat_有机形态': '有机形态',
  'ecat_数字废墟': '数字废墟',
  'ecat_特殊形状': '特殊形状',
  'ecat_云朵条纹': '云朵条纹',
  'ecat_Kawaii像素': 'Kawaii像素',

  // Effect labels (used in custom panel)
  'fx_textureBackground': '纹理背景 Texture BG',
  'fx_gradientOverlay': '渐变蒙版 Gradient',
  'fx_triangleGrid': '三角网格 TriGrid',
  'fx_backgroundBlocks': '背景色块 Blocks',
  'fx_breathingBlocks': '呼吸方块 Blocks',
  'fx_checkerboard': '棋盘格 Checker',
  'fx_concentricCircles': '同心圆 Circles',
  'fx_diamondShapes': '菱形 Diamonds',
  'fx_crossPattern': '十字图案 Cross',
  'fx_scatteredShapes': '散布形状 Shapes',
  'fx_halftoneBlocks': '半调色块 Halftone',
  'fx_shadowShapes': '阴影形状 Shadow',
  'fx_centeredSquares': '居中方块 Squares',
  'fx_balancingCircles': '平衡圆 Circles',
  'fx_radialRectangles': '放射矩形 RadialRect',
  'fx_starTrail': '星轨 StarTrail',
  'fx_planet': '行星 Planet',
  'fx_flowingLines': '流动线条 Lines',
  'fx_diagonalFill': '斜线填充 Diagonal',
  'fx_diagonalHatch': '斜线网格 Hatch',
  'fx_parallelogramStripes': '平行四边形 Stripes',
  'fx_diagonalSplit': '对角分割 Split',
  'fx_diagonalStructure': '对角线结构 DiagStruct',
  'fx_burstLines': '放射线 Burst',
  'fx_screenBorder': '屏幕边框 Border',
  'fx_dashedGuideLines': '虚线参考 Dashed',
  'fx_perspectiveGrid': '透视网格 PerspGrid',
  'fx_compositionGuides': '构成线 CompGuide',
  'fx_webLines': '蛛网线 WebLines',
  'fx_heroText': '主标题 Hero',
  'fx_scatteredText': '散布文字 Scattered',
  'fx_textStrip': '文字条 Strip',
  'fx_textCards': '文字卡片 Cards',
  'fx_bigOutlineText': '大字描边 BigText',
  'fx_cuteOutlineText': '可爱描边 CuteText',
  'fx_layeredText': '叠层文字 Layered',
  'fx_glowTextCards': '发光卡片字 GlowCards',
  'fx_verticalSubText': '竖排副文字 VertSub',
  'fx_formulaText': '公式文字 Formula',
  'fx_fallingText': '文字雨 Falling',
  'fx_staggeredText': '错落文字 Staggered',
  'fx_colorMask': '颜色蒙版 Mask',
  'fx_chromaticAberration': '色差 Chromatic',
  'fx_glitchBars': '故障条 Glitch',
  'fx_vignette': '暗角 Vignette',
  'fx_scanlines': '扫描线 Scanlines',
  'fx_filmGrain': '胶片噪点 Grain',
  'fx_dotScreen': '网点纹理 Dots',
  'fx_hudCorners': 'HUD角框 Corners',
  'fx_hudStatusText': 'HUD状态 Status',
  'fx_hudInfoPanel': 'HUD信息卡 Panel',
  'fx_rulerGuide': '标尺 Ruler',
  'fx_targetGuide': '瞄准线 Target',
  'fx_motionBrackets': '运动框 Motion',
  'fx_glowRing': '光圈 GlowRing',
  'fx_lightSpot': '亮光 LightSpot',
  'fx_organicBlob_blob': '有机Blob Blob',
  'fx_organicBlob_wave': '海浪 Wave',
  'fx_organicBlob_cloud': '云团 Cloud',
  'fx_smearBrush': '涂抹笔触 Smear',
  'fx_noiseText': '乱码文字 NoiseText',
  'fx_dataMonitors': '数据终端 Monitors',
  'fx_paperTear': '撕裂纸张 PaperTear',
  'fx_jigsawGrid': '拼图网格 Jigsaw',
  'fx_edgeClouds': '边缘云朵 EdgeClouds',
  'fx_pinkStripes': '粉色条纹 PinkStripes',
  'fx_pinkGrid': '粉色格子 PinkGrid',
  'fx_scalloppedBorder': '上下花边 Scallop',
  'fx_pulsingCircle': '跃动圆形 Pulse',
  'fx_pixelWindow': '像素窗口 PixelWin',
  'fx_desktopIcon': '桌面图标 Icon',
  'fx_pixelBackground': '像素背景 PixelBG',
  'fx_pixelTypewriter': '像素打字机 PixelType',

  // Hint messages
  'hint_press': '按',
  'hint_hide_panels': '键隐藏面板',

  // Modal messages
  'modal_confirm': '确定',
  'np_fail_title': '监听失败：未检测到 Now Playing 程序运行！',
  'np_fail_body': 'Now Playing 是一款开源免费的、全能的「正在播放」歌曲展示工具，支持检测 20+ 款音乐软件的歌曲信息。您可通过该链接下载使用：',
  'copy_url_settings': '设置',
  'copy_url_transparent_bg': '透明背景',
  'copy_url_use_template': '使用当前模板',
  'copy_url_copy_btn': '复制',
  'url_copied': 'URL 已复制到剪贴板',
  'listen_np_tip': '需要运行 Now Playing 服务，自动获取音乐软件正在播放的歌曲并同步显示歌词',
  'copy_url_tip': '生成可直接粘贴到 OBS 浏览器源的 URL，自动隐藏面板 / 透明背景 / 加载指定模板',

  // WesingCap
  'listen_wesingcap': '监听 Nexus WesingCap',
  'listen_wesingcap_tip': '需要运行 Metabox Nexus WesingCap 服务，自动获取全民K歌正在播放的歌词',
  'nwc_fail_title': '监听失败：未检测到 Nexus WesingCap 服务运行！',
  'nwc_fail_body': 'Metabox Nexus WesingCap 是一款读取全民K歌桌面端正在播放歌曲歌词的工具。您可通过该链接了解详情：',
  'nwc_settings_title': 'Nexus WesingCap 设置',
  'nwc_ws_addr': 'WebSocket 地址',
  'nwc_ws_addr_placeholder': '默认 localhost:8765',
  'nwc_save': '保存',
  'nwc_saved': '已保存',
  'nwc_disconnected': 'WesingCap 连接已断开，监听已停止',

  // Copyright
  'license_title': 'AGPL-3.0 开源协议',
  'license_text': '本工具基于 GNU Affero General Public License v3.0 开源。',
  'license_source': '源代码',
  'license_copyright': '© 2026 PV Tool — AGPL Community Edition',
} as const;

export type LocaleKey = keyof typeof zh;
